@use 'themes/westfield' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;

.googleButton {
  border: color('borderPrimary') solid 1px;
  height: 48px;
  font-size: 16px;
  border-radius: 2px;
  background-color: color('surfaceTertiary');
  color: color('textPrimary');
  text-transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-font-smoothing: initial;
  -moz-osx-font-smoothing: initial;
}

.continueWithGoogle {
  margin-left: 16px;
}
